import { GridProps } from '@lsy-netline/netline-ui';
import { MouseEventHandler, useCallback } from 'react';
import { useTranslation } from 'react-i18next';

import icons from 'icons';
import { Button, Grid } from 'netline-ui';
import { ErrorAction } from 'types';

type ErrorActionProps = GridProps & {
  actions?: ErrorAction[];
};

const ErrorActions = ({ className, actions, ...props }: ErrorActionProps) => {
  const {
    t,
    i18n: { exists },
  } = useTranslation();

  const handleActionClick = useCallback<MouseEventHandler<HTMLButtonElement>>(
    (event) => {
      const clickedAction = actions?.find((action) => action.id === event.currentTarget.dataset.actionId);
      clickedAction?.onClick(clickedAction);
    },
    [actions],
  );

  return (
    <Grid className={className} container spacing={2} {...props}>
      {actions?.map(({ id, text, primary, icon }, idx) => {
        const primaryButton = primary ?? !idx;
        const Icon = icon && icons[icon];
        return (
          <Grid key={id} item xs={false}>
            <Button
              primary={primaryButton}
              onClick={handleActionClick}
              data-action-id={id}
              data-testid="ErrorAction-action"
              startIcon={Icon && <Icon />}
            >
              {exists(text) ? t(text) : text}
            </Button>
          </Grid>
        );
      })}
    </Grid>
  );
};

export default ErrorActions;
